import {
  FaAward,
  FaCertificate,
  FaChartLine,
  FaClipboardCheck,
  FaCogs,
  FaComments,
  FaFileAlt,
  FaGlobeAmericas,
  FaHotel,
  FaIndustry,
  FaLaptopCode,
  FaLeaf,
  FaSearch,
  FaShip,
  FaTools,
  FaTruck,
  FaTshirt,
  FaUserCheck,
  FaUtensils,
} from "react-icons/fa";

/**
 * Decorative UI icons for the Home page sections.
 * These are illustrative only — they are not certification marks.
 */
export const homeIcons = {
  // Core services
  certificate: FaCertificate,
  sustainability: FaLeaf,
  // Why choose us
  experience: FaAward,
  support: FaClipboardCheck,
  global: FaGlobeAmericas,
  improvement: FaChartLine,
  // Certification process
  consultation: FaComments,
  gap: FaSearch,
  documentation: FaFileAlt,
  implementation: FaTools,
  audit: FaUserCheck,
  certification: FaCertificate,
  // Industries (also reused by core services)
  food: FaUtensils,
  textile: FaTshirt,
  it: FaLaptopCode,
  manufacturing: FaIndustry,
  industry: FaIndustry,
  engineering: FaCogs,
  hospitality: FaHotel,
  export: FaShip,
  supplyChain: FaTruck,
};

export default homeIcons;
